import React, { Component } from "react";
import Trello from "node-trello";
import BoardsAssember from "./BoardsAssembler";

const t = new Trello(
  "8398ffdb0c49b47c4052399bd04835f6",
  "48995953408538ac8828d96320244948d8fd26e4ac3103288b974519542fe69a"
);

class BoardsLoader extends Component {
  constructor(props) {
    super(props);
    this.handleLoading = this.handleLoading.bind(this);
    this.state = {
      boards: false,
      requests: 0
    };
  }

  componentWillMount() {
    this.handleLoading();
  }

  async handleLoading() {
    t.get("/1/members/me/boards", async (err, data) => {
      if (err) throw err;
      this.setState(
        {
          boards: data,
          requests: this.state.requests + 1
        },
        async () => {
          this.state.boards.map(async (board, i, boards) => {
            setTimeout(() => {
              t.get(`/1/boards/${board.id}/lists`, async (err, data) => {
                if (err) throw err;
                let newBoards = Object.assign(this.state.boards);
                newBoards[i].lists = data;
                this.setState(
                  {
                    boards: newBoards,
                    requests: this.state.requests + 1
                  },
                  () => {
                    this.state.boards[i].lists.map(async (list, j, lists) => {
                      setTimeout(() => {
                        t.get(
                          `/1/lists/${list.id}/cards`,
                          async (err, data) => {
                            if (err) throw err;
                            let newNewBoards = Object.assign(this.state.boards);
                            newNewBoards[i].lists[j].cards = data;
                            this.setState({
                              boards: newNewBoards,
                              requests: this.state.requests + 1
                            });
                          }
                        );
                      }, i * 1000 + j * 1000);
                    });
                  }
                );
              });
            }, i * 1000);
          });
        }
      );
    });
  }

  render() {
    let progress = this.state.requests / 200 * 100;
    progress = progress.toString() + "%";
    const loaderStyle = { width: progress };
    const bl = this.state.boards.length;
    if (
      !this.state.boards ||
      !this.state.boards[bl - 1].lists ||
      !this.state.boards[bl - 1].lists[
        this.state.boards[bl - 1].lists.length - 1
      ].cards
    ) {
      return (
        <div className="wrapper">
          <h1>loading</h1>
          <p>requests: {this.state.requests}</p>
          <div className="loaderWrapper">
            <div className="loader" style={loaderStyle} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="wrapper">
          <BoardsAssember boards={this.state.boards} />
        </div>
      );
    }
  }
}

export default BoardsLoader;



// WEBPACK FOOTER //
// ./src/BoardsLoader.js